import { Navigate, type RouteObject, useParams } from 'react-router-dom';
import { SAMPLE_NOTE_PATH, SAMPLE_ROUTE_BASE } from '@features/sample-note/constants';

/**
 * The public sample experience: the real NoteChatView and Patient Page V3
 * trees on committed fixture data. Registered as a top-level sibling of the
 * authenticated tree, so it never enters AuthenticatedLayout and needs no
 * session.
 *
 * `/demo/*` was the previous generation (deleted); permanent redirects keep
 * old links from marketing emails, the product tour, and the Chrome extension
 * working.
 */
const LegacyDemoRedirect: React.FC = () => {
  // Every legacy demo note id maps onto the single new sample note.
  useParams();
  return <Navigate to={SAMPLE_NOTE_PATH} replace />;
};

export const sampleNoteRoutes: RouteObject[] = [
  {
    path: SAMPLE_ROUTE_BASE,
    async lazy() {
      const { SampleExperienceLayout } = await import(
        '@features/sample-note/SampleExperienceLayout'
      );
      return { Component: SampleExperienceLayout };
    },
    children: [
      {
        index: true,
        element: <Navigate to={SAMPLE_NOTE_PATH} replace />,
      },
      {
        path: 'patient/:patientId',
        async lazy() {
          const { SamplePatientView } = await import('@features/sample-note/SamplePatientView');
          return { Component: SamplePatientView };
        },
      },
      {
        path: ':noteId',
        async lazy() {
          const { SampleNoteView } = await import('@features/sample-note/SampleNoteView');
          return { Component: SampleNoteView };
        },
      },
    ],
  },
  {
    path: '/demo',
    element: <Navigate to={SAMPLE_NOTE_PATH} replace />,
  },
  {
    path: '/demo/:noteId',
    element: <LegacyDemoRedirect />,
  },
];
